import './index.scss';
import { create } from '../../utils/dom';
import { CLASS_BLOCK_NAME, SIZE_18x18 } from './constants';

export default class Icon {
    constructor(icon, size = SIZE_18x18, iconText, ...modifiers) {
        this.el = create('div', CLASS_BLOCK_NAME, iconText);

        modifiers.unshift(size);
        modifiers.unshift(icon);

        modifiers.forEach(this.addModifier.bind(this));
    }

    /**
     * Adds a css bem modifier
     * @param {String} modifier The modifier name
     * @return {void}
     */
    addModifier(modifier) {
        this.el.classList.add(`${CLASS_BLOCK_NAME}--${modifier}`);
    }

    /**
     * Removes a css bem modifier
     * @param {String} modifier The modifier name
     * @return {void}
     */
    removeModifier(modifier) {
        this.el.classList.remove(`${CLASS_BLOCK_NAME}--${modifier}`);
    }
}
